import * as React from "react";
import { useFormContext } from "react-hook-form";
import { DropdownInput } from "../../../runQuote/components/DropdownInput";
import { SwitchInput } from "../../../runQuote/components/SwitchInput";
import { TextInput } from "../../../runQuote/components/TextInput";
import { Checkbox } from "../../../../components/ui/checkbox";
import { Label } from "../../../../components/ui/label";

const INSURANCE_STATUS = [
  { value: "Yes currently insured", label: "Yes currently insured" },
  { value: "Yes currently not insured", label: "Yes currently not insured" },
  { value: "No", label: "No" },
];

const BI_LIMITS = [
  { value: "State Minimum Limits", label: "State Minimum Limits" },
  {
    value: "Greater than State Min but lower than 100/300",
    label: "Greater than State Min but lower than 100/300",
  },
  { value: "100/300", label: "100/300" },
  { value: "250/500", label: "250/500" },
  { value: "500/500", label: "500/500" },
];

const YEARS_WITH_CARRIER = [
  { value: "6 months", label: "6 months" },
  { value: "1 year", label: "1 year" },
  { value: "2 years", label: "2 years" },
  { value: "3 years", label: "3 years" },
  { value: "4 years", label: "4 years" },
  { value: "5 years", label: "5 years" },
  { value: "greater than 5 years", label: "greater than 5 years" },
];

const PIP_CLAIMS = [
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "More Than 5", label: "More Than 5" },
];

const RESIDENTS = Array.from({ length: 10 }, (_, i) => {
  const val = String(i + 1);
  return { value: val, label: val };
});

const PRIMARY_RESIDENCE = [
  { value: "Own Home/Condo", label: "Own Home/Condo" },
  { value: "Own Manufactured Home", label: "Own Manufactured Home" },
  { value: "Rent", label: "Rent" },
  { value: "Other", label: "Other" },
];

export function InsuredHistory() {
  const { control, register, setValue, watch } = useFormContext();
  const rentersDiscount = watch("step5.rentersDiscount");
  const priorInsuranceStatus = watch("step5.priorInsuranceStatus");
  const showPriorDetails = priorInsuranceStatus !== "No";

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold">Insured History</h2>

      <DropdownInput
        control={control}
        label="Insured/Spouse has vehicle liability insurance for past 6 months with no more than 31 days lapse?"
        dropdownLabel="Select"
        stepName="step5.priorInsuranceStatus"
        stepId="step5"
        itemList={INSURANCE_STATUS}
      />

      {showPriorDetails && (
        <>
          <TextInput
            register={register}
            label="Prior Insurance Carrier"
            id="priorInsuranceCarrier"
            stepName="step5.priorInsuranceCarrier"
            stepId="step5"
          />

          <DropdownInput
            control={control}
            label="What were the Bodily Injury limits on your most recent policy?"
            dropdownLabel="Select"
            stepName="step5.bodilyInjuryLimits"
            stepId="step5"
            itemList={BI_LIMITS}
          />

          <DropdownInput
            control={control}
            label="Number of years with your most recent auto insurance carrier?"
            dropdownLabel="Select"
            stepName="step5.yearsWithCarrier"
            stepId="step5"
            itemList={YEARS_WITH_CARRIER}
          />
        </>
      )}

      <SwitchInput
        control={control}
        id="driversListed"
        stepName="step5.driversListed"
        stepId="step5"
        label="Have you included all drivers required to be listed within the driver section of the quote?"
      />

      <DropdownInput
        control={control}
        label="How many PIP claims in the past 5 years?"
        dropdownLabel="Select"
        stepName="step5.pipClaims"
        stepId="step5"
        itemList={PIP_CLAIMS}
      />

      <div className="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-600">
        PLEASE NOTE: All personal auto policies with Cover Badger are required to be paperless
      </div>

      <DropdownInput
        control={control}
        label="Total number of residents living in the home including listed drivers, excluded drivers, children and roommates:"
        dropdownLabel="Select"
        stepName="step5.totalResidents"
        stepId="step5"
        itemList={RESIDENTS}
      />

      <DropdownInput
        control={control}
        label="Primary Residence"
        dropdownLabel="Select"
        stepName="step5.primaryResidence"
        stepId="step5"
        itemList={PRIMARY_RESIDENCE}
      />

      <div className="space-y-2">
        <Label>
          Will the insured have a multi-policy discount with Progressive?
        </Label>
        <div className="flex items-center gap-2">
          <Checkbox
            id="rentersDiscount"
            checked={!!rentersDiscount}
            onCheckedChange={(checked) =>
              setValue("step5.rentersDiscount", !!checked, {
                shouldDirty: true,
              })
            }
          />
          <Label htmlFor="rentersDiscount">Renters Insurance</Label>
        </div>
      </div>
    </div>
  );
}
